var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "34", height: "34", viewBox: "0 0 34 34" }, props),
    React.createElement("path", { d: "M31.86 9.97l-14.37 16.8A.63.63 0 0 1 17 27c-.23 0-.4-.08-.49-.23L2.14 9.97c-.16-.18-.18-.4-.07-.64A.58.58 0 0 1 2.63 9h28.74c.26 0 .44.11.56.33.11.25.09.46-.07.64z" })
  );
});


// WEBPACK FOOTER //
// ./node_modules/@tradera/tradera-ui/icons/arrow-down.svg?jsx